@if (formTratamiento && formEnvio) {
  <mat-card>
    <app-card-header
      [title]="'Enviar Móvil'"
      icono="local_shipping"
      [botonCerrar]="true"
      (cerrar)="dialogRef.close()"
    ></app-card-header>

    <form (ngSubmit)="onSubmit()" autocomplete="off">
      <mat-card-content class="card-content-crear">
        <div class="enviar-movil-cuerpo">
          <!-- Formularios -->
          <div class="enviar-movil-campos">
            <app-content-card
              title="Información del tratamiento"
              icon="edit_note"
            >
              <div [formGroup]="formTratamiento">
                <!-- Nota -->
                <section class="inputs-group">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Nota</mat-label>
                    <textarea matInput formControlName="nota"></textarea>
                  </mat-form-field>
                </section>

                <!-- Nota Interna -->
                <section class="inputs-group">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Nota Interna</mat-label>
                    <textarea matInput formControlName="notaInterna"></textarea>
                  </mat-form-field>
                </section>
              </div>
            </app-content-card>

            <app-content-card
              title="Información del envío de móvil"
              icon="local_shipping"
            >
              <div [formGroup]="formEnvio">
                <!-- Vehiculo -->
                <section class="inputs-group">
                  <ng-select
                    [items]="vehiculos"
                    bindLabel="modelo"
                    bindValue="_id"
                    placeholder="Móviles disponibles"
                    [notFoundText]="'No hay moviles disponibles'"
                    style="width: 100%"
                    multiple="false"
                    [searchFn]="buscarVehiculo"
                    searchable="true"
                    appendTo="body"
                    formControlName="idActivo"
                    (change)="asignarVehiculoConductor($event)"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <span>{{ item.identificacion }}</span>
                      @if (item?.vehiculo?.chofer) {
                        <span class="dato-secundario">
                          {{
                            item?.vehiculo?.chofer?.datosPersonales?.nombre ||
                              item?.vehiculo?.chofer?.usuario
                          }}
                        </span>
                      }
                      @if (item?.distanciaAlEvento) {
                        <span>
                          a {{ item.distanciaAlEvento / 1000 | number }} km
                        </span>
                      }
                      @if (item?.cantidadEnvios) {
                        <span class="dato-secundario">
                          (Eventos pendientes: {{ item.cantidadEnvios }})
                        </span>
                      }
                    </ng-template>

                    <ng-template
                      ng-option-tmp
                      let-item="item"
                      let-item$="item$"
                      let-index="index"
                    >
                      <div style="padding-bottom: 5px">
                        <span>{{ item.identificacion }}</span>
                        @if (item?.vehiculo?.chofer) {
                          <span class="dato-secundario">
                            {{
                              item?.vehiculo?.chofer?.datosPersonales?.nombre ||
                                item?.vehiculo?.chofer?.usuario
                            }}
                          </span>
                        }
                        @if (item?.distanciaAlEvento) {
                          <span>
                            a {{ item.distanciaAlEvento / 1000 | number }} km
                          </span>
                        }
                        @if (item?.cantidadEnvios) {
                          <span class="dato-secundario">
                            (Eventos pendientes: {{ item.cantidadEnvios }})
                          </span>
                        }
                      </div>
                    </ng-template>
                  </ng-select>
                </section>

                <!-- Detalles -->
                <section class="inputs-group">
                  <mat-form-field appearance="outline" class="full-width">
                    <mat-label>Detalles</mat-label>
                    <textarea matInput formControlName="detalles"></textarea>
                  </mat-form-field>
                </section>
              </div>
            </app-content-card>
          </div>

          <!-- Mapa -->
          <div class="enviar-movil-mapa">
            @if (mapCardConfig) {
              <app-map-card
                [config]="mapCardConfig"
                height="450px"
                (entityClick)="onMarkerClick($event)"
              ></app-map-card>
            }
          </div>
        </div>
      </mat-card-content>

      <mat-card-actions class="actions-create">
        <button irxBoton="secundario" type="button" (click)="dialogRef.close()">
          Cancelar
        </button>
        <button
          irxBoton="principal"
          type="submit"
          [disabled]="
            !this.formTratamiento.valid || !this.formEnvio.valid || loading
          "
        >
          <mat-icon>check</mat-icon>
          Enviar
        </button>
      </mat-card-actions>
    </form>
  </mat-card>
}
